export const titlesModal = {
    listWorker: "Lista de trabajadores",
    listWorker_sub: "Agregar trabajadores",
};